// Admin Shop tab — Products | Services | Orders sub-toggle.
import { useState } from 'react';
import ProductsList from './ProductsList';
import AdminServicesTab from './AdminServicesTab';
import AdminOrdersTab from './AdminOrdersTab';

// showOrders: the Orders screen is switched on for this user (backend/features.py)
export default function ShopTab({ showOrders = false }) {
  const [sub, setSub] = useState('products');

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-gray-100 p-1 flex">
        <button
          data-testid="admin-shop-sub-products"
          onClick={() => setSub('products')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-extrabold uppercase tracking-wider ${
            sub === 'products' ? 'bg-[#2B3A67] text-white' : 'text-gray-500'
          }`}
        >
          Products
        </button>
        <button
          data-testid="admin-shop-sub-services"
          onClick={() => setSub('services')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-extrabold uppercase tracking-wider ${
            sub === 'services' ? 'bg-[#2B3A67] text-white' : 'text-gray-500'
          }`}
        >
          Services
        </button>
        {showOrders && (
        <button
          data-testid="admin-shop-sub-orders"
          onClick={() => setSub('orders')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-extrabold uppercase tracking-wider ${
            sub === 'orders' ? 'bg-[#2B3A67] text-white' : 'text-gray-500'
          }`}
        >
          Orders
        </button>
        )}
      </div>

      {sub === 'products' ? <ProductsList /> : sub === 'services' ? <AdminServicesTab />
        : showOrders ? <AdminOrdersTab /> : null}
    </div>
  );
}
